<template>
  <v-tooltip bottom :disabled="!tooltipText">
    <template v-slot:activator="{ on }">
      <v-btn
        small
        :text="isText"
        v-on="on"
        v-bind="$attrs"
        class="d-flex justify-start"
        @click="handleClick"
        :class="specificClass"
        :outlined="outlined"
        tile
      >
        <v-icon left>{{ icon }}</v-icon>
        <slot v-if="hasSlot" />
        <truncate-text-with-hover :text="btnText" :length="20" v-else />
      </v-btn>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>
<script>
import TruncateTextWithHover from '@/components/tools/TruncateTextWithHover';

export default {
  name: 'CustomBtnIcon',
  components: {
    TruncateTextWithHover,
  },
  props: {
    btnText: { type: String },
    tooltipText: { type: String },
    icon: { type: String },
    outlined: { type: Boolean },
    specificClass: { type: String },
    isText: { type: Boolean, default: true },
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>
